import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { useDispatch, useSelector } from 'react-redux';
import {setCalendarDateRange} from '../../../redux/reducers/CalendarRangeSlice';
import { useEffect, useRef,useState } from 'react';
import $ from "jquery";
import React from 'react';
import { dateFormat, getRangeDates } from '../../../services/Util';
import Constants from '../../../Constants';
export default function DateRangeSelector(props) {
  const [nextAriaLabel,setNextAriaLabel] = useState('Go to next month')
  const [prevAriaLabel,setPrevAriaLabel] = useState('Go to previous month')
  const [next2AriaLabel,setNext2AriaLabel] = useState('Go to next year')
  const [prev2AriaLabel,setPrev2AriaLabel] = useState('Go to previous year')
  const [viewType,setViewType] = useState('month')
  const dispatch = useDispatch();
  const showCustomNavigationLabel = (date, label, locale, view) =>{
    return <span aria-label={` date: ${dateFormat(date,'MMMM - YYYY')}`}>{dateFormat(date,'MMMM - YYYY')}</span>
  }
  const viewChange = (action, activeStartDate, value, view) =>{
    setViewType(view)
    if(view === 'month'){
      setNextAriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.NEXT_MONTH)
      setPrevAriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.PREV_MONTH)
      setNext2AriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.NEXT_YEAR)
      setPrev2AriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.PREV_YEAR)
    }
    if(view === 'year'){
      setNextAriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.NEXT_YEAR)
      setPrevAriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.PREV_YEAR)
      setNext2AriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.NEXT_DECADE)
      setPrev2AriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.PREV_DECADE)
    }
    if(view === 'decade'){
      $('.react-calendar__tile--hasActive').addClass("decade-active");
      $('.react-calendar__tile--hasActive').focus()
      setNextAriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.NEXT_DECADE)
      setPrevAriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.PREV_DECADE)
      setNext2AriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.NEXT_CENTURY)
      setPrev2AriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.PREV_CENTURY)
    }
    if(view === 'century'){
      $('.react-calendar__tile--hasActive').addClass("decade-active");
      $('.react-calendar__tile--hasActive').focus()
      setNextAriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.NEXT_CENTURY)
      setPrevAriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.PREV_CENTURY)
    }
  }
  const selectDate = (value,event) =>{
    var activeClass = 0
    setTimeout(()=>{
      $.each($('.react-calendar__tile'), function( index, value ) {
        var containFirst = value.classList.contains("react-calendar__tile--rangeStart")
        var containLast = value.classList.contains("react-calendar__tile--rangeEnd")
          activeClass = activeClass+ 1
          var arialabel = value?.children[0]?.ariaLabel
          if(containFirst){
            if(viewType === 'month'){
              $(value).attr('aria-label', "Selected start date "+arialabel);
            }
            if(viewType === 'year'){
               var startMonth = dateFormat(new Date(arialabel),'MMMM')
               $(value).attr('aria-label', "Selected start month "+startMonth);
            }
          }else if(containLast){
            if(viewType === 'month'){
              $(value).attr('aria-label', "Selected end date "+arialabel);
            }
            if(viewType === 'year'){
              var endMonth = dateFormat(new Date(arialabel),'MMMM')
              $(value).attr('aria-label', "Selected end month "+endMonth);
           }
          }
    });
    },500)
  }
  useEffect(()=>{
    $.each($('.react-calendar__tile'), function( index, value ) {
      var containFirst = value.classList.contains("react-calendar__tile--rangeStart")
      var containLast = value.classList.contains("react-calendar__tile--rangeEnd")
        var arialabel = value?.children[0]?.ariaLabel
        if(containFirst){
          if(viewType === 'month'){
            $(value).attr('aria-label', "Selected start date "+arialabel);
          }
          if(viewType === 'year'){
             var startMonth = dateFormat(new Date(arialabel),'MMMM')
             $(value).attr('aria-label', "Selected start month "+startMonth);
          }
        }
        else if(containLast){
          if(viewType === 'month'){
            $(value).attr('aria-label', "Selected end date "+arialabel);
          }
          if(viewType === 'year'){
            var endMonth = dateFormat(new Date(arialabel),'MMMM')
            $(value).attr('aria-label', "Selected end month "+endMonth);
         }
        }
        
      else{
        $(value).attr('aria-label', value?.children[0]?.ariaLabel);
      }
    });
  });

  const defaultDateRange = getRangeDates(Constants.DEFAULT_DATE_RANGE);

  const onDateChange = (returnValue) => {
    if (props.onDateChange) {
      props.onDateChange(returnValue)
    } else {
      dispatch(setCalendarDateRange(returnValue));
    }
  }

  return (
      <Calendar 
      calendarType={props.calendarType} 
      locale={props.locale} 
      selectRange={props.selectRange}
      className={props.className}
      returnValue="range"
      onChange = {(returnValue, event) => onDateChange(returnValue)}
      onClickDay={(value, event) => selectDate(value,event)}
      showNeighboringMonth={false}
      showDoubleView={props.showDoubleView}
      hover={new Date()}
      navigationLabel={ ({ date, label, locale, view })=>showCustomNavigationLabel(date, label, locale, view)}
      onViewChange={({ action, activeStartDate, value, view }) => viewChange(action, activeStartDate, value, view)}
      value={props.value ? props.value : defaultDateRange}
      nextAriaLabel={nextAriaLabel}
      prevAriaLabel={prevAriaLabel}
      next2AriaLabel={next2AriaLabel}
      prev2AriaLabel={prev2AriaLabel}
        />
  );
}